import React from 'react';

const ForgotPasswordPage = (): JSX.Element => <div>Forgot password page</div>;

export default ForgotPasswordPage;
